import React from 'react';
import type { FC } from 'react';
import { Text } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import type { BackOfficeExtensionContainer } from '@wix/extensions-data-client';
import type { ComponentGenerationResult } from '@wix/gena';
import { GenerationSuccessMessage } from '../../GenerationSuccessMessage.js';

const customGroupMessages = new Map([
  ['Checkout & Orders', 'generate_command.generation.ecommerce_notification'],
]);

export const DashboardPluginGeneratedNote: FC<{
  backofficeExtensionWidget: BackOfficeExtensionContainer;
  generatedFiles: ComponentGenerationResult['newFiles'];
}> = ({ backofficeExtensionWidget, generatedFiles }) => {
  const { t } = useTranslation();

  const extensionType = t(
    'generate_command.flow.dashboard_plugin'
  ).toLowerCase();

  const customKey = customGroupMessages.get(backofficeExtensionWidget.appName);

  return (
    <GenerationSuccessMessage
      extensionType={extensionType}
      generatedFiles={generatedFiles}
      // https://dev.wix.com/docs/build-apps/developer-tools/cli/wix-cli-for-apps/extensions/dashboard-plugin-extension-files-and-code
      learnMoreUrl="https://wix.to/dFFuEki"
    >
      {customKey ? <Text>{t(customKey)}</Text> : null}
    </GenerationSuccessMessage>
  );
};
